/**
 * Return an array of size `n` that is "filled" so it can be mapped to generate
 * other data
 */
export function range(n: number) {
    return new Array(n).fill(0);
}
